import { sortFunc } from "../../services/utilities";
import { CallToActionTwoTone } from "@material-ui/icons";

const initialState = {
  watchlists: [],
  watchlistInstrumentsMap: {},
  formattedWatchlists: [],
  trackIndex: 0,
  pins: [],
  searchResults: [],
  searchBasketResults: [],
  searchDepthResults: [],
  searchMode: [],
  optionChainData: [],
  futureChainData: [],
  cellOptions: [
    // {label:'Display Name', key:'display_name', value : true},
    { label: "Open Interest", key: "currentOpenInterest", value: true },
    { label: "% Change", key: "currentOI", value: true },
    { label: "Close Price", key: "close_price", value: true },
    { label: "LTP", key: "ltp", value: true },
  ],
  cellOptionsGreeks:
    localStorage.getItem("cellOptionsGreekVal") &&
    localStorage.getItem("cellOptionsGreekVal") !== null
      ? JSON.parse(localStorage.getItem("cellOptionsGreekVal"))
      : [
          // {label:'Display Name', key:'display_name', value : true},
          { label: "Open Interest", key: "currentOpenInterest", value: true },
          { label: "% Change", key: "currentOI", value: true },
          { label: "Close Price", key: "close_price", value: true },
          { label: "LTP", key: "ltp", value: true },
          { label: "Delta", key: "delta", value: false },
          { label: "Gamma", key: "gamma", value: false },
          { label: "Theta", key: "theta", value: false },
          { label: "Vega", key: "vega", value: false },
          { label: "Rho", key: "rho", value: false },
          { label: "IV", key: "iv", value: false },
        ],
  gainersLosers: [],
  watchListIndex: 0,
  depthActivePrice: {
    token: 0,
    exchange: 0,
    price: 0,
    orderSide: "",
    trading_symbol: "",
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_WATCHLISTS":
      return {
        ...state,
        watchlists: action.payload,
      };
    case "SET_FORMATTED_WATCHLISTS":
      return {
        ...state,
        formattedWatchlists: action.payload,
      };
      
    case "RENAME_WATCHLIST": {
      const { watchlistIndex, name } = action.payload;
      const updatedWatchlists = [...state.watchlists];
      updatedWatchlists[watchlistIndex] = {
        ...updatedWatchlists[watchlistIndex],
        name,
      };
      const updatedFormatted = updatedWatchlists.map((mw, index) => ({
        ...mw,
        mappedName: mw.name || `MW-${index + 1}`,
      }));
      return {
        ...state,
        watchlists: updatedWatchlists,
        formattedWatchlists: updatedFormatted,
      };
    }
      
    case "SET_INSTRUMENT_LIST":
      return {
        ...state,
        watchlistInstrumentsMap: action.payload,
      };

    case "ADD_NEW_INSTRUMENT":
      const watchlistIndex = action.payload.watchlistIndex;
      const marketwatchesCopy = [...state.watchlists];
      marketwatchesCopy[watchlistIndex].instruments.splice(0, 0, {
        ...action.payload.data,
        ltp: 0,
        absoluteChange: 0,
        percentChange: 0,
        ltt: 0,
        lowDpr: 0,
        highDpr: 0,
        currentOpenInterest: 0,
        initialOpenInterest: 0,
        selectedClass: "",
      });
      let instrumentsListTemp = new Map();
      marketwatchesCopy.map((watchlist)=>{
        let arr = [];
        if(watchlist.instruments.length !== 0){
          watchlist.instruments.map((instrument)=>{
            arr.push(`${instrument.exchange}+${instrument.token}`);
          })
        }
         instrumentsListTemp.set(watchlist.id,arr)
      })
      return {
        ...state,
        watchlists: marketwatchesCopy,
        watchlistInstrumentsMap: instrumentsListTemp,
      };

      case "DELETE_INSTRUMENT": {
        const instrumentsListTemp = new Map(); // Initialize instrumentsListTemp properly
        
        action.payload.forEach((watchlist) => {
          const arr = []; // Initialize an array for each watchlist
          
          if (watchlist.instruments.length !== 0) {
            watchlist.instruments.forEach((instrument) => {
              arr.push(`${instrument.exchange}+${instrument.token}`);
            });
          }
          
          instrumentsListTemp.set(watchlist.id, arr);
        });
      
        return {
          ...state,
          watchlists: action.payload,
          watchlistInstrumentsMap: instrumentsListTemp, // Use the initialized map here
        };
      }

    case "SET_PINNED_INSTRUMENTS":
      return {
        ...state,
        pins: action.payload,
      };

    case "SORT_CURRENT_MARKETWATCH": {
      const copyWatchlist = [...state.watchlists];
      const currInstruments =
        state.watchlists[action.payload.watchlistIndex].instruments;

      const sortedInstruments = sortFunc(
        currInstruments,
        action.payload.keyName,
        action.payload.order
      );

      const {
        exchange: activeExg,
        token: activeToken,
      } = action.payload.activeInstrument;

      const index = sortedInstruments.findIndex(
        ({ exchange, token }) =>
          `${exchange}-${token}` === `${activeExg}-${activeToken}`
      );

      copyWatchlist[action.payload.watchlistIndex].instruments = [
        ...sortedInstruments,
      ];

      return {
        ...state,
        watchlists: copyWatchlist,
        trackIndex: index,
      };
    }

    case "REORDER_MARKETWATCH":
      const arrWatchlist = [...state.watchlists];
      const currInstrumentList = action.payload.currInstruments;

      arrWatchlist[action.payload.watchlistIndex].instruments = [
        ...currInstrumentList,
      ];

      return {
        ...state,
        watchlists: arrWatchlist,
        trackIndex: action.payload.index,
      };

    case "SET_INITIAL_TRACK_INDEX":
      return {
        ...state,
        trackIndex: action.payload,
      };

    case "SET_INCREMENT_TRACK_INDEX":
      const incrementInstrumentLength = action.payload;
      let incrementActiveIndex;
      if (state.trackIndex < incrementInstrumentLength - 1) {
        incrementActiveIndex = state.trackIndex + 1;
      } else if (state.trackIndex === incrementInstrumentLength - 1) {
        incrementActiveIndex = 0;
      }
      return {
        ...state,
        trackIndex: incrementActiveIndex,
      };

    case "SET_DECREMENT_TRACK_INDEX":
      const decrementInstrumentLength = action.payload;
      let decrementActiveIndex;
      if (state.trackIndex > 0) {
        decrementActiveIndex = state.trackIndex - 1;
      } else if (state.trackIndex === 0) {
        decrementActiveIndex = decrementInstrumentLength - 1;
      }
      return {
        ...state,
        trackIndex: decrementActiveIndex,
      };
    case "SET_SEARCH_RESULT":
      return {
        ...state,
        searchResults: action.payload,
      };
    case "SET_BASKET_SEARCH_RESULT":
      return {
        ...state,
        searchBasketResults: action.payload,
      };
    case "SET_DEPTH_SEARCH_RESULT":
      return {
        ...state,
        searchDepthResults: action.payload,
      };
    case "SET_PRICE_FROM_DEPTH":
      return {
        ...state,
        depthActivePrice: action.payload,
      };
    case "SET_DAY_GAINERS_LOSERS":
      return {
        ...state,
        gainersLosers: action.payload,
      };
    case "SET_WATCHLISTINDEX":
      return {
        ...state,
        watchListIndex: action.payload,
      };
    case "SET_OPTION_CHAIN_DATA":
      return {
        ...state,
        optionChainData: action.payload
      };
    case "SET_FUTURE_CHAIN_DATA":
      return {
        ...state,
        futureChainData: action.payload
      }; 
    case "SHOW_HIDE_CELL_OPTIONS":
      return {
        ...state,
        cellOptions: [...action.payload],
        cellOptionsGreeks: [...action.payload]
      }
    default:
      return state;
  }
}
